import type {
	LoanEventFilters,
	LoanFilters,
	LoanViewFilters,
	LoanShareholderFilters,
} from 'ui/ManagerFinance/Loans/types'
import { callApi, callApiLg } from './api/finance-api'
import { generateQueryParams } from 'util/queryUtils'
import type {
	CreateLoan,
	CreateLoanEvent,
	CreateLoanShareCalculation,
} from '@viilu-web/shared'

export const _getLoan = async (loanUUID: string) => {
	return callApi(`/v1/loan/${loanUUID}`, {
		method: 'GET',
	})
}

export const _getLoans = async (loanFilters: LoanFilters) => {
	return callApi(`/v1/loan${generateQueryParams(loanFilters)}`, {
		method: 'GET',
	})
}

export const _getLoanShareholder = async (
	loanUUID: string,
	shareholderUUID: string,
) => {
	return callApi(`/v1/loan/${loanUUID}/shareholders/${shareholderUUID}`, {
		method: 'GET',
	})
}

export const _getLoanEvents = async (
	loanUUID: string,
	filters: LoanEventFilters,
) => {
	return callApi(`/v1/loan/${loanUUID}/events${generateQueryParams(filters)}`, {
		method: 'GET',
	})
}

export const _getLoanShareCalculation = async (
	loanUUID: string,
	filters: LoanViewFilters,
) => {
	return callApi(
		`/v1/loan/${loanUUID}/loan-share-calculation${generateQueryParams(
			filters,
		)}`,
		{
			method: 'GET',
		},
	)
}

export const _getLoanCalculationSnapshotByUUID = async (
	loanUUID: string,
	snapshotUUID: string,
) => {
	return callApi(
		`/v1/loan/${loanUUID}/loan-calculation-snapshot/${snapshotUUID}`,
		{
			method: 'GET',
		},
	)
}

export const _generateLoanShareCalculationPdf = async (
	loanUUID: string,
	data: CreateLoanShareCalculation,
) => {
	return callApiLg(`/v1/loan/${loanUUID}/loan-share-calculation/pdf-create`, {
		method: 'POST',
		body: {
			...data,
		},
	})
}

export const _createLoanEvent = async (
	loanUUID: string,
	data: CreateLoanEvent,
) => {
	return callApi(`/v1/loan/${loanUUID}/events`, {
		method: 'POST',
		body: {
			...data,
		},
	})
}

export const _getShareholders = async (filters: LoanShareholderFilters) => {
	return callApi(`/v1/loan/shareholders${generateQueryParams(filters)}`, {
		method: 'GET',
	})
}

export const _createLoan = async (
	data: CreateLoan,
	paymentProductUUID?: string,
) => {
	return callApi(`/v1/loan`, {
		method: 'POST',
		body: {
			data: { ...data },
			paymentProductUUID,
		},
	})
}

export const _updateLoan = async (
	loanUUID: string,
	data: CreateLoan,
	paymentProductUUID?: string,
) => {
	return callApi(`/v1/loan/${loanUUID}`, {
		method: 'PUT',

		body: {
			data: { ...data },
			paymentProductUUID,
		},
	})
}

export const _deleteLoan = async (loanUUID: string) => {
	return callApi(`/v1/loan/${loanUUID}`, {
		method: 'DELETE',
	})
}
